import * as React from "react";
const SvgFiRrPuzzle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-puzzle_svg__a)">
      <path
        fill="#062147"
        d="M13 24h-1.569a1 1 0 0 1-.957-1.291c.286-.878.463-1.788.526-2.709a2 2 0 0 0-4 0 11.2 11.2 0 0 0 .526 2.709A1 1 0 0 1 6.569 24H5a5.006 5.006 0 0 1-5-5v-8a5.006 5.006 0 0 1 5-5h.272A10 10 0 0 1 5 4a4 4 0 0 1 8 0 10 10 0 0 1-.272 2H13a5.006 5.006 0 0 1 5 4.773c.656-.158 1.326-.25 2-.273a4 4 0 1 1 0 8 10 10 0 0 1-2-.272V19a5.006 5.006 0 0 1-5 5m-.272-2H13a3 3 0 0 0 3-3v-2.069a1 1 0 0 1 1.291-.957c.878.286 1.788.463 2.709.526a2 2 0 0 0 0-4c-.921.063-1.831.24-2.709.526A1 1 0 0 1 16 12.069V11a3 3 0 0 0-3-3h-1.569a1 1 0 0 1-.957-1.291c.286-.878.463-1.788.526-2.709a2 2 0 1 0-4 0 11.2 11.2 0 0 0 .526 2.709A1 1 0 0 1 6.569 8H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h.272A10 10 0 0 1 5 20a4 4 0 1 1 8 0 10 10 0 0 1-.272 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-puzzle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPuzzle;
